export default {
    g_bool: 3029738,
    g_true: 3569038,
    g_false: 97196323,
    g_int: 104431,
    g_long: 3327612,
    g_ulong: 111379569,
    g_double: -1325958191,
    g_string: -891985903,
    g_template: -1321546630,
    g_null: 3392903,
    g_matrix: -1081239615,
    g_number: -1034364087,
    g_double_array: 1372483691,
    g_int_array: 315522569,
    g_long_array: -340537642,
    g_ulong_array: -130449141,
    g_array: 93090393,
    g_node: 3386882,
    g_function: 1380938712,
    g_meta_key: -450143963,
    g_var_key: 236497223,
    g_var_key_new: -1817082200,
    g_var_offset: 1857392811,
    g_offset: -1019779949,
    g_read_offset: -715377828,
    g_src: 114148,
    g_result: -934426595,
    g_declare_var: -2025425198,
    g_assign_var: 1025861591,
    g_free_var: -1538001196,
    g_master_index: -809507659,
    g_load_master_index: 1863200622,
    g_load_global_index: -1948757009,
    g_new_global_index: -847221387,
    g_configure_index: 602712633,
    g_configure: -804429082,
    g_add_to_index: 799961068,
    g_query_index: -927797605,
    g_it: 3371,
    g_it_offset: 1187069479,
    g_it_key: -1178841781,
    g_return: -934396624,
    g_if_then_else: 615401849,
    g_while: 113101617,
    g_operator: -500553564,
    g_then: 3558941,
    g_else: 3116345,
    g_all: 96673,
    g_name: 3373707,
    g_names: 104585032,
    g_types: 110844025,
    g_result_temp: -537084234,
    g_meta: 3347973,
    g_session: 1984987798,
    g_sessions: 1405079709,
    g_node_generator: -266917674,
    g_session_generator: -344828822,
    g_id: 3355,
    g_ids: 104120,
    g_this: 3559070,
    g_prop: 3449699,
    g_key: 106079,
    g_keys: 3288564,
    g_binary_op: -998221089,
    g_new_node: 1377157441,
    g_new_object: 615178942,
    g_new_object_at: 170503508,
    g_object_type: -1277176774,
    g_repeat: -934531685,
    g_connect: 951351530,
    g_sync: 3545755,
    g_merge: 103785528,
    g_print: 106934957,
    g_print_append: -227267348,
    g_print_all: -1796653809,
    g_set: 113762,
    g_value: 111972721,
    g_value2: -823812895,
    g_values: -823812830,
    g_any: 96748,
    g_any_node: -349683595,
    g_page: 3433103,
    g_pages: 106426308,
    g_seq: 113759,
    g_offsets: -1548407232,
    g_function_key: -210856584,
    g_from: 3151786,
    g_type: 3575610,
    g_type_attribute: -664210473,
    g_foreach: -677682614,
    g_new_time: 1377330700,
    g_get_time: 1976672790,
    g_new_node_timepoint: 1594333541,
    g_timeline: -2076650431,
    g_time: 3560141,
    g_load: 3327206,
    g_load_all: 1845922504,
    g_index: 100346066,
    g_query: 107944136,
    g_lookup: -1097094790,
    g_lookup_all: 1300432220,
    g_default: 1544803905,
    g_reference: -925155509,
    g_index_hash: 746783835,
    g_index_hash_candidates: 1662498228,
    g_index_hash_values: 741411206,
    g_resolved_values: -2001143991,
    g_index_result: 689728554,
    g_global_index: -326497994,
    g_add: 96417,
    g_to: 3707,
    g_ordinal: -1206994319,
    g_param: 106436749,
    g_set_attribute: 1302056703,
    g_set_reference: 363815854,
    g_set_at: -905789136,
    g_read_property: -520479138,
    g_read_properties: -1964257412,
    g_execute_property: -1651463329,
    g_console: 951510359,
    g_nb: 3508,
    g_sub: 114240,
    g_i: 105,
    g_j: 106,
    g_k: 107,
    g_callee_origin: -426083577,
    g_callee_session: -1431227691,
    g_new_session: 1240347383,
    g_noop: 3387234,
    g_std: 114211,
    g_path: 3433509,
    g_port: 3446913,
    g_leveldb: 69785346,
    g_rocksdb: 1368770220,
    g_websocket_server: -339307845,
    g_websocket_client: -791193789,
    g_url: 116079,
    g_openblas: -504225978,
    g_cublas: -1349602962,
    g_eigen: 96505900,
    g_hybridblas: 1573138936,
    g_mqtt: 3359524,
    g_mqtt_topic: 680036436,
    g_mqtt_topics_list: 389591614,
    g_mqtt_custom_parser: 1265754834,
    g_opcua_server: 2105970676,
    g_opcua_client: 1654084732,
    g_opcua_node_identifier_list: 661706024,
    g_node_identifier: -1608655098,
    g_gateway: -189118908,
    g_remotes: 1091834093,
    g_subscriptions: 1987365622,
    g_cursor: -1349119146,
    g_max: 107876,
    g_grafana: 280038788,
    g_use_wss: -147675553,
    g_cert: 3050020,
};
//# sourceMappingURL=keys.js.map